import { postAsync, getAsync, patchAsync } from "./http-client";

const NotificationApi = {
  get: async (params) => {
    return await postAsync("/notification/list/ceo", params);
  },
  getStatus: async (params) => {
    return await getAsync("/notification/unread/count");
  },
  seen: async (params) => {
    return await postAsync("/notification/updateRead");
  },
  updateSetting: async (data) => {
    return await patchAsync("/notification/settingReceive",data);
  },
};
export default NotificationApi;
